<button class="mat-dialog-close" [mat-dialog-close]="false">
  <mat-icon svgIcon="close"></mat-icon>
</button>

<!-- Dialog: Header -->
<div class="mat-dialog-header">
  <h2 *ngIf="data.title">{{ data.title }}</h2>
</div>

<!-- Dialog: Content -->
<div class="mat-dialog-body mb-20">
  <ng-container *ngIf="!data.isValid; else validContent">
    <p class="invalid-address"><b>The address entered cannot be validated</b></p>
    <p *ngIf="data.content">Do you want to use the entered address? <br/> {{ data.content }}</p>
  </ng-container>
  <ng-template #validContent>
    <p *ngIf="data.content">Do you want to use the validated address? <br/> {{ data.content }}</p>
  </ng-template>
</div>

<!-- Dialog: Footer/Actions -->
<div class="mat-dialog-footer" mat-dialog-actions>
  <ng-container *ngIf="data.stackedButtons; then stacked; else default"></ng-container>

  <ng-template #default>
    <div class="btn-group btn-group--fill">
      <button class="btn btn-outline" [title]="data.cancelBtnText" [mat-dialog-close]="false">
        {{ data.cancelBtnText }}
      </button>
      <button cdkFocusInitial class="btn btn-primary" [title]="data.enteredBtnText" (click)="selectAddress('entered')">
        {{ data.enteredBtnText }}
      </button>
      <ng-container *ngIf="data.isValid">
      <button class="btn btn-outline" [title]="data.validateBtnText" (click)="selectAddress('validated')">
        {{ data.validateBtnText }}
      </button>
    </ng-container>
    </div>
  </ng-template>

  <ng-template #stacked>
    <div class="btn-group-vertical">
      <button class="btn btn-link" [title]="data.cancelBtnText" [mat-dialog-close]="false">
        {{ data.cancelBtnText }}
      </button>
      <button cdkFocusInitial class="btn btn-primary" [title]="data.enteredBtnText" (click)="selectAddress('entered')">
        {{ data.enteredBtnText }}
      </button>
      <button class="btn btn-outline" [title]="data.validateBtnText" (click)="selectAddress('validated')">
        {{ data.validateBtnText }}
      </button>
    </div>
  </ng-template>
</div>
